<template>
  <v-app>
    <div class="app-container">
      <v-main class="bg main-content">
        <!-- Normal NavBar -->
        <NavBar v-if="showNavBar" />

        <!-- KYC NavBar -->
        <NavBarKYC v-if="showKycNavBar" />

        <!-- Layout with Sidebar for dashboard pages -->
        <div v-if="showNavBar">
          <SideBar />
          <div class="flex-grow-1">
            <router-view />
          </div>
        </div>

        <!-- Router view without sidebar for other pages -->
        <router-view v-else />
      </v-main>

      <FooterBar />
    </div>

    <!-- Global Session Timeout Dialog (moved outside v-main) -->
    <DialogSessionTimeout 
      :dialog="showSessionTimeoutDialog" 
      @login="handleSessionTimeout"
      @update:dialog="showSessionTimeoutDialog = $event" 
    />
  </v-app>
</template>

<script>
import { defineComponent, watch } from "vue";
import NavBar from "./components/appBar/navBar.vue";
import NavBarKYC from "./components/appBar/navBarKyc.vue";
import SideBar from "./components/appBar/sideBar.vue";
import FooterBar from "./components/appBar/footerBar.vue";
import { eventBus } from '@/utils/eventBus';
import DialogSessionTimeout from '@/components/dialogs/dialogSessionTimeout.vue';

export default defineComponent({
  name: "App",
  components: { NavBar, NavBarKYC, SideBar, FooterBar, DialogSessionTimeout },
  data() {
    return { 
      isConnected: false,
      showSessionTimeoutDialog: false
    };
  },
  computed: {
    showNavBar() {
      const excludedPaths = ["/kyc-application", "/kyc-status", "/"];
      return this.isConnected && !excludedPaths.includes(this.$route.path);
    },
    showKycNavBar() {
      const kycPaths = ["/kyc-application", "/kyc-status"];
      return this.isConnected && kycPaths.includes(this.$route.path);
    }
  },
  mounted() {
    this.checkConnectionStatus();
    window.addEventListener("account-connected", this.checkConnectionStatus);
    window.addEventListener("storage", this.checkConnectionStatus);
    
    // Watch eventBus using Composition API watch
    watch(
      () => eventBus.showSessionTimeout,
      (newVal) => {
        console.log('🔔 Session timeout watcher triggered:', newVal);
        this.showSessionTimeoutDialog = newVal;
      },
      { immediate: true }
    );
    
    console.log('✅ App mounted, watching eventBus');
  },
  unmounted() {
    window.removeEventListener("account-connected", this.checkConnectionStatus);
    window.removeEventListener("storage", this.checkConnectionStatus);
  },
  methods: {
    checkConnectionStatus() {
      this.isConnected = !!sessionStorage.getItem("zetrixAccount");
    },
    handleSessionTimeout() {
      console.log('🚪 Handling session timeout...');
      
      // Clear storage
      localStorage.clear();
      sessionStorage.clear();
      
      // Hide dialog
      this.showSessionTimeoutDialog = false;
      eventBus.hideSessionTimeout();
      
      // Redirect to login
      this.$router.push('/');
      
      // Reload page to clear any cached state
      setTimeout(() => {
        window.location.reload();
      }, 100);
    }
  }
});
</script>

<style>
.bg {
  background-color: #F8F9F9;
}

.app-container {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.main-content {
  flex: 1;
}
</style>